import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { buildLocalePath } from "./locale-utils";
import { getLocaleFromPath } from "./locale-utils";

/**
 * Sets document.title (using the i18n translation key if available)
 * and updates the canonical link for the current page.
 * Uses locale-prefixed paths for canonical URLs.
 */
export function usePageSEO(titleKey: string, path: string) {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    // Try to resolve as an i18n key first; fall back to the raw string
    const translated = t(titleKey, { defaultValue: titleKey });
    document.title = translated;
    let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (link) {
      const locale = getLocaleFromPath(window.location.pathname);
      const canonicalPath = buildLocalePath(locale, path);
      link.href = "https://wccalendar.com" + canonicalPath;
    }
  }, [titleKey, path, i18n.language]);
}
